module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/trips/trip-list/trip-list.component.css
// module id = ./src/app/components/trips/trip-list/trip-list.component.css
// module chunks = main